import React from "react";

import { Container, ErrorMessage, Input } from "./input.styled";

type TextFieldProps = {
  ref?: any;
  isUI?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  label?: string;
  name?: string;
  type?: string;
  placeholder?: string;
  height?: string;
  color?: string;
  value?: string;
  touched?: boolean;
  error?: boolean;
  multiline?: boolean;
  size?: "small" | "medium";
  rows?: number;
  errorMessage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

const TextField = ({
  isUI,
  color,
  disabled,
  error,
  fullWidth,
  label,
  name,
  value,
  touched,
  type = "string",
  placeholder,
  height,
  multiline,
  rows,
  errorMessage,
  size,
  onBlur,
  onChange,
}: TextFieldProps) => {
  const textFieldStyle = {
    fontFamily: "NotoSans-Medium",
    fontSize: 16,
    height: height ? height : undefined,
  };
  return (
    <Container>
      <Input
        sx={{
          "& .MuiInputBase-input": {
            height: "auto",
          },
        }}
        InputProps={{
          style: textFieldStyle,
        }}
        fullWidth={fullWidth}
        disabled={disabled}
        error={!!(errorMessage && touched)}
        label={label}
        name={name}
        size={size ? size : undefined}
        type={type}
        multiline={multiline}
        rows={rows}
        placeholder={placeholder}
        color="primary"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
      {touched && errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};

export default TextField;
